<template>
  <div class="adjustPublish">
    <el-row>
      <el-col :span="24">
        <el-table class="table-status" ref="tableData" :data="subVersionList" border header-cell-class-name="headerStyle" cell-class-name="cellStyle" :cell-style="columnStyle" :row-class-name="tableRowClassName">
          <el-table-column label="奖金版本">
            <template slot-scope="scope">
              <span @click="getQuarterBonusListStatus_TABLE(scope.$index, scope.row)">{{scope.row.versionNameSub}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间"></el-table-column>
          <el-table-column prop="createUser" label="创建人"></el-table-column>
          <el-table-column prop="deployState" label="发布状态">
            <template slot-scope="scope">
              <el-tag :type="scope.row.deployState === '1' ? 'success' : 'danger'" disable-transitions>{{scope.row.deployState==='1'?'已发布':'未发布'}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="deployTime" label="发布时间"></el-table-column>
          <el-table-column prop="calculateState" label="试算状态">
            <template slot-scope="scope">
              <el-tag :type="scope.row.calculateState === '1' ? 'success' : 'danger'" disable-transitions>{{scope.row.calculateState===null?'否':'是'}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="试算">
            <template slot-scope="scope">
              <el-tag style="cursor:pointer;" @click="callTrial(scope.row)" disable-transitions>试算</el-tag>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="24">
        <!-- <el-button style="margin:10px 0" type="primary" size="small" @click="trialAdj()">调整计算</el-button> -->
        <el-form class="searchClass mt10" :inline="true" :model="searchList" label-width="100px" label-position="top">
          <el-form-item style="width:180px" label="区域">
            <el-select v-model="searchList.region" @change="changeChange" placeholder="请选择区域">
              <el-option :label="item.label" :value="item.label" v-for="(item, index) in region" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="width:180px" label="城市">
            <el-select v-model="searchList.city" @change="changeChange" placeholder="请选择城市">
              <el-option :label="item.label" :value="item.label" v-for="(item, index) in city" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="width:200px" label="员工姓名">
            <el-select v-model="searchList.employeeNm" @change="changeChange" filterable placeholder="请选择或输入员工姓名">
              <el-option :label="item.label" :value="item.label" v-for="item in employeeNm" :key="item.label"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="width:180px" label="岗位级别">
            <el-select v-model="searchList.roleLevel" @change="changeChange" placeholder="请选择岗位级别">
              <el-option :label="item.label" :value="item.label" v-for="(item, index) in roleLevel" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="width:180px" label="业务指标">
            <el-select v-model="searchList.kpi" @change="changeChange" placeholder="请选择业务指标">
              <el-option :label="item.label" :value="item.label" v-for="(item, index) in kpi" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="width:200px" label="MUDID">
            <el-select v-model="searchList.mudId" @change="changeChange" filterable placeholder="请选择或输入MUDID">
              <el-option :label="item.label" :value="item.label" v-for="item in mudId" :key="item.label"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item style="width:180px" label="奖金基数">
            <el-select v-model="searchList.incentiveRate" @change="changeChange" placeholder="请选择奖金基数">
              <el-option :label="item.label" :value="item.label" v-for="(item, index) in incentiveRate" :key="index"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item style="width:180px" label="是否调整">
            <el-select v-model="searchList.isAdjust" @change="changeChange" placeholder="请选择是/否">
              <el-option label="是" value="Y"></el-option>
              <el-option label="否" value="N"></el-option>
              <!-- <el-option :label="item.label === 'Y' ? '是' : '否'" :value="item.label" v-for="(item, index) in isAdjust" :key="index"></el-option> -->
            </el-select>
          </el-form-item>
          <el-form-item style="width:180px" label="kpi达成">
            <el-select v-model="searchList.kpiAch" @change="changeChange" placeholder="请选择零/非零">
              <el-option label="零" value="0"></el-option>
              <el-option label="非零" value="1"></el-option>
            </el-select>
          </el-form-item>
          <br>
          <div>
            <!-- <el-form-item>
              <el-button type="primary" @click="search()">搜 索</el-button>
            </el-form-item> -->
            <el-form-item>
              <el-button @click="resetSearch()" plain>清 空</el-button>
            </el-form-item>
            <el-form-item style="float:right">
              <el-button type="primary" @click="addAttachment()">添加附件</el-button>
            </el-form-item>
          </div>
        </el-form>
      </el-col>
      <el-col :span="24">
        <el-table class="table-status" v-loading="fullscreenLoading" ref="tableDataAdjustRef" :data="tableDataAdjust" @selection-change="selectionChange" height="430" border header-cell-class-name="headerStyle1" :cell-style="columnStyle1" cell-class-name="cellStyle">
          <el-table-column width="60" prop="year" label="年">
            <!-- 奖金合计时加粗显示 -->
            <!-- <template slot-scope="scope"><span :class="scope.row.kpi==='奖金合计'?'totalClass':''">{{scope.row.year}}</span></template> -->
          </el-table-column>
          <el-table-column width="60" prop="quarter" :key="Math.random()" v-if="versionNameSub.indexOf('Yearly') === -1" label="季度"></el-table-column>
          <el-table-column width="100" prop="channel" label="渠道"></el-table-column>
          <el-table-column width="80" prop="region" label="区域"></el-table-column>
          <el-table-column width="150" prop="city" label="城市"></el-table-column>
          <el-table-column width="100" prop="employeeId" label="员工编码"></el-table-column>
          <el-table-column width="100" prop="mudId" label="MUDID"></el-table-column>
          <el-table-column width="80" prop="roleId" label="岗位编号"></el-table-column>
          <el-table-column width="200" prop="roleNm" label="岗位描述"></el-table-column>
          <el-table-column width="80" prop="roleLevel" label="岗位级别"></el-table-column>
          <el-table-column width="80" prop="monthCnt" :key="Math.random()" v-if="versionNameSub.indexOf('Yearly') === -1" label="在岗月份"></el-table-column>
          <el-table-column width="100" prop="jointDate" label="入职日期"></el-table-column>
          <el-table-column width="100" prop="leftDate" label="离职日期"></el-table-column>
          <el-table-column width="80" prop="employeeNm" label="员工姓名"></el-table-column>
          <el-table-column width="200" prop="roleDesc" label="政策岗位名称"></el-table-column>
          <el-table-column width="200" prop="kpi" label="业务指标"></el-table-column>
          <el-table-column width="80" prop="incentiveRate" label="奖金基数"></el-table-column>
          <el-table-column width="160" :label="versionNameSub.indexOf('Yearly') === -1 ? '季度发放比例' : '年度发放比例'" align="center">
            <el-table-column width="80" prop="quarterRate" label="发放比例">
              <template slot-scope="scope">{{scope.row.quarterRate}}%</template>
            </el-table-column>
            <el-table-column width="80" prop="quarterRateAdjust" label="编辑">
              <template slot-scope="scope">
                <el-input :disabled="scope.row.kpi==='奖金合计'" v-model="scope.row.quarterRateAdjust" @change.native.prevent="changeRowQuarterRateAdjust(scope.row)"><i slot="suffix" class="el-input__icon">%</i></el-input>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column width="140" label="权重" align="center">
            <el-table-column width="60" prop="kpiWeight" label="权重">
              <template slot-scope="scope">{{scope.row.kpiWeight}}%</template>
            </el-table-column>
            <el-table-column width="80" prop="kpiWeightAdjust" label="编辑">
              <template slot-scope="scope">
                <el-input :disabled="scope.row.kpi==='奖金合计'" v-model="scope.row.kpiWeightAdjust" @change="changeRowKpiWeightAdjust(scope.row)"><i slot="suffix" class="el-input__icon">%</i></el-input>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column width="140" label="达成" align="center">
            <el-table-column width="60" prop="kpiAch" label="达成"></el-table-column>
            <el-table-column width="80" prop="kpiAchAdjust" label="编辑">
              <template slot-scope="scope">
                <el-input :disabled="scope.row.kpi==='奖金合计'" v-model="scope.row.kpiAchAdjust" @change="changeRowKpiAchAdjust(scope.row)"></el-input>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column width="190" label="达成系数" align="center">
            <el-table-column width="80" prop="coffient" label="达成系数"></el-table-column>
            <el-table-column width="110" prop="coffientAdjust" label="编辑">
              <template slot-scope="scope">
                <el-input :disabled="scope.row.kpi==='奖金合计'" v-model="scope.row.coffientAdjust" @change="changeRowCoffientAdjust(scope.row)"></el-input>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column width="160" label="最终结果" align="center">
            <el-table-column width="80" prop="kpiScore" label="调整前"></el-table-column>
            <el-table-column width="80" prop="adjustAfterKpiScore" label="调整后"></el-table-column>
          </el-table-column>
          <el-table-column width="80" label="是否压货">
            <template slot-scope="scope">{{scope.row.isOverStock==='1' ? '是' : '否'}}</template>
          </el-table-column>
          <el-table-column width="260" label="备注" align="center">
            <el-table-column width="80" label="描述">
              <template slot-scope="scope">
                <span class="operation" @click="viewDes(scope.row)">查看</span>
              </template>
            </el-table-column>
            <!-- <el-table-column width="80" label="上传附件">
              <template slot-scope="scope">
                <i class="el-icon-upload2 downloadIcon" @click="uploadTips" v-if="scope.row.quarterRateAdjust === null && scope.row.kpiWeightAdjust === null && scope.row.kpiAchAdjust === null && scope.row.coffientAdjust === null"></i>
                <el-upload v-else ref="uploadRef" :multiple='false' action :http-request="upload" :data={id:scope.row.id} :show-file-list='false' :before-upload="beforeUpload">
                  <i class="el-icon-upload2 downloadIcon"></i>
                </el-upload>
              </template>
            </el-table-column> -->
            <el-table-column type="selection" width="100"></el-table-column>
            <el-table-column width="80" label="下载附件">
              <template slot-scope="scope">
                <i class="el-icon-download downloadIcon" @click="download(scope.row)"></i>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="24" class="foot_button">
        <el-pagination @current-change="pagesChange" :current-page="currentPage" :page-size=size layout="total, prev, pager, next, jumper" :total=total></el-pagination>
      </el-col>
      <el-col :span="24" class="foot_button">
        <el-button type="primary" size="small" @click="trialAdj()">调整计算</el-button>
        <el-button type="primary" size="small" @click="saved()">保存</el-button>
        <el-button type="primary" size="small" @click="publish()">发布</el-button>
        <el-button type="primary" size="small" @click="downloadExcel()">下载</el-button>
        <el-button type="primary" size="small" @click="rowToColumnDownload()">奖金报告下载</el-button>
      </el-col>
    </el-row>
    <el-dialog title="上传附件和描述" width="40%" :visible.sync="dialog" @close='cancel()'>
      <el-form ref="editDataRef" :rules="editDataRules" :model="editData" label-width="80px">
        <el-form-item prop="attachment" label="上传附件">
          <el-upload :multiple='false' action :http-request="upload" :data={id:1} :show-file-list='false' :before-upload="beforeUpload">
            <el-button type="primary" size="small">上传附件</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item prop="adjustGistDesc" label="描述">
          <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 4}" v-model="editData.adjustGistDesc"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-w" @click="cancel()">取 消</el-button>
        <el-button class="btn" type="primary" @click="confirm()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'adjustPublish',
  data () {
    return {
      subVersionList: [], // 季度列表
      tableDataAdjust: [], // 数据列表
      tableDataAdjustAll: [], // 数据列表-清除筛选后全部数据--不用
      highLight: '', // 高亮行
      tableDataAdjustCalu: [], // 调整之后数据列表
      versionNameSub: '', // 2020-医院-Q1
      version: '', // 版本号
      versionName: '', // 2020-医院渠道
      searchList: {
        region: null,
        city: null,
        employeeNm: null,
        roleLevel: null,
        kpi: null,
        incentiveRate: null,
        mudId: null,
        isAdjust: null,
        kpiAch: null
      },
      // 筛选条件
      region: [],
      city: [],
      employeeNm: [],
      roleLevel: [],
      kpi: [],
      incentiveRate: [],
      mudId: [],
      isAdjust: [],
      // 分页
      pages: 0,
      total: 0,
      size: 0,
      currentPage: 0,
      dialog: false, // 附件描述弹框
      editData: {
        adjustGistDesc: '',
        attachment: ''
      },
      editDataRules: {
        adjustGistDesc: [
          { required: true, message: '请输入描述', trigger: 'blur' },
          { min: 2, max: 200, message: '长度在 2 到 200 个字符', trigger: 'blur' }
        ],
        attachment: [
          { required: true, message: '请上传附件', trigger: 'blur' }
        ]
      },
      id: '', // 附件id
      multipleSelection: [], // 多选数据
      fullscreenLoading: false // 遮罩层
    }
  },
  created () {},
  mounted () {},
  methods: {
    // 奖金调整-季度列表
    getQuarterBonusList (versionName) {
      // versionName--2020-医院渠道
      this.subVersionList = []
      this.$http.get(this.API.versionInfoSub, { params: { pVersionName: versionName } }).then((res) => {
        let data = res.data
        if (data.code === 200) {
          this.subVersionList = data.data
        } else {
          this.$message.error('接口调用失败！')
        }
      })
    },
    // 调用试算结果--table首列值
    getQuarterBonusListStatus_TABLE (index, row) {
      // console.log(row)
      this.highLight = index
      // 调用试算结果
      this.trialResult(row)
    },
    // 试算--调用SQL
    callTrial (row) {
      // console.log(row)
      this.fullscreenLoading = true
      this.tableDataAdjust = []
      this.tableDataAdjustCalu = []
      this.$http.get(this.API.callTrial, { params: { subVersionName: row.versionNameSub } }).then((res) => {
        // console.log(res)
        let data = res.data
        if (data.code === 200) {
          this.fullscreenLoading = false
          if (data.data.records.length > 0) {
            // 调用季度奖金列表
            this.getQuarterBonusList(row.versionName)
            // 赋值季度版本号和版本号
            this.versionNameSub = row.versionNameSub
            this.versionName = row.versionName
            this.version = data.data.version
            // 分页
            this.pages = data.data.pages
            this.total = data.data.total
            this.size = data.data.size
            this.currentPage = data.data.current
            // 赋值数据列表
            let tableDataAdjust = data.data.records
            // console.log(tableDataAdjust)
            // 筛选项
            let region = []
            let city = []
            let employeeNm = []
            let roleLevel = []
            let kpi = []
            let incentiveRate = []
            let mudId = []
            let isAdjust = []
            this.region = this.FilterRendering(data.data.regions, region)
            this.city = this.FilterRendering(data.data.citys, city)
            this.employeeNm = this.FilterRendering(data.data.employeeNms, employeeNm)
            this.roleLevel = this.FilterRendering(data.data.roleLevels, roleLevel)
            this.kpi = this.FilterRendering(data.data.kpis, kpi)
            this.incentiveRate = this.FilterRendering(data.data.incentiveRates, incentiveRate)
            this.mudId = this.FilterRendering(data.data.mudIds, mudId)
            this.isAdjust = this.FilterRendering(data.data.isAdjusts, isAdjust)
            tableDataAdjust.forEach((ele) => {
            // 奖金基数
              ele.incentiveRate = this.formatNum(ele.incentiveRate, 4)
              // 季度发放比例
              // ele.quarterRate = this.formatNum(ele.quarterRate, 2)
              ele.quarterRate = this.formatNum100(ele.quarterRate, 2)
              ele.quarterRateAdjust = this.formatNum100(ele.quarterRateAdjust, 2)
              // 权重
              ele.kpiWeight = this.formatNum(ele.kpiWeight, 0)
              // 达成
              ele.kpiAch = this.formatNum(ele.kpiAch, 2)
              ele.kpiAchAdjust = this.formatNum(ele.kpiAchAdjust, 2)
              // 达成系数
              ele.coffient = this.formatNum(ele.coffient, 4)
              ele.coffientAdjust = this.formatNum(ele.coffientAdjust, 4)
              // 最终结果
              ele.kpiScore = this.formatNum(ele.kpiScore, 4)
              ele.adjustAfterKpiScore = this.formatNum(ele.adjustAfterKpiScore, 4)
            })
            tableDataAdjust.sort(this.mysort)
            this.tableDataAdjust = tableDataAdjust
            // 清除筛选项
            this.searchList = this.templateData()
            this.$message.success('试算成功！')
          } else {
            this.$message.warning('暂无数据！')
          }
        } else {
          this.fullscreenLoading = false
          this.$message.error('接口调用失败！')
        }
      })
    },
    // 查询试算结果
    trialResult (row) {
      this.fullscreenLoading = true
      this.tableDataAdjust = []
      this.tableDataAdjustCalu = []
      let obj = {}
      obj.pageNum = 1
      obj.pageSize = 20
      obj.subVersionName = row.versionNameSub
      this.$http.post(this.API.trialResult, obj).then((res) => {
        let data = res.data
        // console.log(res)
        if (data.code === 200) {
          this.fullscreenLoading = false
          if (data.data.records.length > 0) {
            // 赋值季度版本号和版本号
            this.versionNameSub = row.versionNameSub
            this.versionName = row.versionName
            this.version = data.data.version
            // 分页
            this.pages = data.data.pages
            this.total = data.data.total
            this.size = data.data.size
            this.currentPage = data.data.current
            // 赋值数据列表
            let tableDataAdjust = data.data.records
            // console.log(tableDataAdjust)
            let region = []
            let city = []
            let employeeNm = []
            let roleLevel = []
            let kpi = []
            let incentiveRate = []
            let mudId = []
            let isAdjust = []
            this.region = this.FilterRendering(data.data.regions, region)
            this.city = this.FilterRendering(data.data.citys, city)
            this.employeeNm = this.FilterRendering(data.data.employeeNms, employeeNm)
            this.roleLevel = this.FilterRendering(data.data.roleLevels, roleLevel)
            this.kpi = this.FilterRendering(data.data.kpis, kpi)
            this.incentiveRate = this.FilterRendering(data.data.incentiveRates, incentiveRate)
            this.mudId = this.FilterRendering(data.data.mudIds, mudId)
            this.isAdjust = this.FilterRendering(data.data.isAdjusts, isAdjust)
            tableDataAdjust.forEach((ele) => {
            // 奖金基数
              ele.incentiveRate = this.formatNum(ele.incentiveRate, 4)
              // 季度发放比例
              // ele.quarterRate = this.formatNum(ele.quarterRate, 2)
              ele.quarterRate = this.formatNum100(ele.quarterRate, 2)
              ele.quarterRateAdjust = this.formatNum100(ele.quarterRateAdjust, 2)
              // 权重
              ele.kpiWeight = this.formatNum(ele.kpiWeight, 0)
              // 达成
              ele.kpiAch = this.formatNum(ele.kpiAch, 2)
              ele.kpiAchAdjust = this.formatNum(ele.kpiAchAdjust, 2)
              // 达成系数
              ele.coffient = this.formatNum(ele.coffient, 4)
              ele.coffientAdjust = this.formatNum(ele.coffientAdjust, 4)
              // 最终结果
              ele.kpiScore = this.formatNum(ele.kpiScore, 4)
              ele.adjustAfterKpiScore = this.formatNum(ele.adjustAfterKpiScore, 4)
            })
            tableDataAdjust.sort(this.mysort)
            this.tableDataAdjust = tableDataAdjust
            // 清除筛选项
            this.searchList = this.templateData()
          } else {
            this.$message.warning('暂无数据！')
          }
        } else {
          this.$message.error('接口调用失败！')
          this.fullscreenLoading = false
        }
      }).catch(() => {
        this.fullscreenLoading = false
      })
    },
    // 分页--
    pagesChange (v) {
      // console.log(v)
      if (this.version) {
        this.fullscreenLoading = true
        this.tableDataAdjust = []
        let obj = {}
        obj.pageNum = v
        obj.pageSize = this.size
        obj.version = this.version
        obj.subVersionName = this.versionNameSub
        obj.regions = this.searchList.region === null ? null : this.searchList.region.split(',')
        obj.citys = this.searchList.city === null ? null : this.searchList.city.split(',')
        obj.employeeNms = this.searchList.employeeNm === null ? null : this.searchList.employeeNm.split(',')
        obj.roleLevels = this.searchList.roleLevel === null ? null : this.searchList.roleLevel.split(',')
        obj.kpis = this.searchList.kpi === null ? null : this.searchList.kpi.split(',')
        obj.incentiveRates = this.searchList.incentiveRate === null ? null : this.searchList.incentiveRate.split(',')
        obj.mudIds = this.searchList.mudId === null ? null : this.searchList.mudId.split(',')
        obj.isAdjusts = this.searchList.isAdjust === null ? null : this.searchList.isAdjust.split(',')
        obj.kpiAch = this.searchList.kpiAch === null ? null : this.searchList.kpiAch * 1
        this.$http.post(this.API.callTrialResult, obj).then((res) => {
          let data = res.data
          if (data.code === 200) {
            this.fullscreenLoading = false
            if (data.data.records.length > 0) {
              // 分页
              this.pages = data.data.pages
              this.total = data.data.total
              this.size = data.data.size
              this.currentPage = data.data.current
              // 赋值数据列表
              let tableDataAdjust = data.data.records
              // console.log(tableDataAdjust)
              let region = []
              let city = []
              let employeeNm = []
              let roleLevel = []
              let kpi = []
              let incentiveRate = []
              let mudId = []
              let isAdjust = []
              this.region = this.FilterRendering(data.data.regions, region)
              this.city = this.FilterRendering(data.data.citys, city)
              this.employeeNm = this.FilterRendering(data.data.employeeNms, employeeNm)
              this.roleLevel = this.FilterRendering(data.data.roleLevels, roleLevel)
              this.kpi = this.FilterRendering(data.data.kpis, kpi)
              this.incentiveRate = this.FilterRendering(data.data.incentiveRates, incentiveRate)
              this.mudId = this.FilterRendering(data.data.mudIds, mudId)
              this.isAdjust = this.FilterRendering(data.data.isAdjusts, isAdjust)
              // 替换调整数据
              let tableDataAdjustCalu = JSON.parse(JSON.stringify(this.tableDataAdjustCalu))
              let tableDataAdjustConcat = []
              tableDataAdjustCalu.forEach(element => {
                element.quarterRate = element.quarterRate === null ? null : element.quarterRate / 100
                element.quarterRateAdjust = element.quarterRateAdjust === null ? null : element.quarterRateAdjust / 100
              })
              let tableDataAdjustNew = tableDataAdjust.filter((item) => {
                return !tableDataAdjustCalu.some(ele => ele.employeeId === item.employeeId && ele.mudId === item.mudId && ele.kpi === item.kpi)
              })
              let tableDataAdjustCaluNew = tableDataAdjustCalu.filter((item) => {
                return tableDataAdjust.some(ele => ele.employeeId === item.employeeId && ele.mudId === item.mudId && ele.kpi === item.kpi)
              })
              // console.log(tableDataAdjustNew)
              // console.log(tableDataAdjustCaluNew)
              if (tableDataAdjustNew.length === tableDataAdjust.length) {
                tableDataAdjustConcat = tableDataAdjust
              } else {
                tableDataAdjustConcat = tableDataAdjustNew.concat(tableDataAdjustCaluNew)
              }
              // console.log(tableDataAdjustConcat)
              tableDataAdjustConcat.forEach((ele) => {
                // 奖金基数
                ele.incentiveRate = this.formatNum(ele.incentiveRate, 4)
                // 季度发放比例
                // ele.quarterRate = this.formatNum(ele.quarterRate, 2)
                ele.quarterRate = this.formatNum100(ele.quarterRate, 2)
                ele.quarterRateAdjust = this.formatNum100(ele.quarterRateAdjust, 2)
                // 权重
                ele.kpiWeight = this.formatNum(ele.kpiWeight, 0)
                // 达成
                ele.kpiAch = this.formatNum(ele.kpiAch, 2)
                ele.kpiAchAdjust = this.formatNum(ele.kpiAchAdjust, 2)
                // 达成系数
                ele.coffient = this.formatNum(ele.coffient, 4)
                ele.coffientAdjust = this.formatNum(ele.coffientAdjust, 4)
                // 最终结果
                ele.kpiScore = this.formatNum(ele.kpiScore, 4)
                ele.adjustAfterKpiScore = this.formatNum(ele.adjustAfterKpiScore, 4)
              })
              tableDataAdjustConcat.sort(this.mysort)
              this.tableDataAdjust = tableDataAdjustConcat
            } else {
              this.$message.warning('暂无数据！')
            }
          } else {
            this.fullscreenLoading = false
            this.$message.error('接口调用失败！')
          }
        })
      } else {
        this.$message.warning('请先试算或查询！')
      }
    },
    // 级联
    changeChange (v) {
      // console.log(v)
      this.cascaderNew()
      // if (!v) {
      //   this.cascaderNew()
      // }
    },
    // 搜索---暂时不用
    search () {
      // 去除null值
      let searchList = this.removePropertyOfNull(this.searchList)
      // console.log(searchList)
      // 每次搜索重新赋值全部
      this.tableDataAdjust = this.tableDataAdjustAll
      // 多条件筛选
      this.tableDataAdjust = this.multiFilter(this.tableDataAdjust, searchList)
      // console.log(this.tableDataAdjust)
    },
    // 清除
    resetSearch () {
      this.searchList = this.templateData()
      this.cascaderNew()
    },
    // 试算调整
    trialAdj () {
      let param = []
      param = this.tableDataAdjustCalu.filter((element) => {
        return element.quarterRateAdjust !== null || element.kpiWeightAdjust !== null ||
            element.kpiAchAdjust !== null || element.coffientAdjust !== null
      })
      if (param.length > 0) {
        let arr = []
        param.forEach((element) => {
          // element.kpiWeight = element.kpiWeight === null ? null : element.kpiWeight.substr(0, element.kpiWeight.length - 1)
          element.quarterRate = element.quarterRate === null ? null : element.quarterRate / 100
          element.quarterRateAdjust = element.quarterRateAdjust === null ? null : element.quarterRateAdjust / 100
          // arr.push(element)
          // 库中表字段不一致特殊处理
          arr.push({
            adjustAfterKpiScore: element.adjustAfterKpiScore,
            channel: element.channel,
            city: element.city,
            coffient: element.coffient,
            kpiCoffientAdjust: element.coffientAdjust,
            employeeId: element.employeeId,
            employeeNm: element.employeeNm,
            id: element.id,
            incentiveRate: element.incentiveRate,
            isAdjust: element.isAdjust,
            isCondition: element.isCondition,
            isDeploy: element.isDeploy,
            isSaved: element.isSaved,
            jointDate: element.jointDate,
            kpi: element.kpi,
            kpiAch: element.kpiAch,
            kpiAchAdjust: element.kpiAchAdjust,
            kpiScore: element.kpiScore,
            kpiWeight: element.kpiWeight,
            kpiWeightAdjust: element.kpiWeightAdjust,
            leftDate: element.leftDate,
            monthCnt: element.monthCnt,
            mudId: element.mudId,
            quarter: element.quarter,
            quarterRate: element.quarterRate,
            quarterRateAdjust: element.quarterRateAdjust,
            region: element.region,
            roleDesc: element.roleDesc,
            roleId: element.roleId,
            roleLevel: element.roleLevel,
            roleNm: element.roleNm,
            subVersionName: element.subVersionName,
            version: element.version,
            year: element.year
          })
        })
        this.fullscreenLoading = true
        this.$http.post(this.API.trialAdj, arr).then((res) => {
          let data = res.data
          // console.log(data)
          if (data.code === 200) {
            this.fullscreenLoading = false
            this.tableDataAdjust = []
            // 控制之前调整过的
            this.tableDataAdjustCalu = []
            let tableDataAdjust = data.data.records
            // 赋值版本号
            this.version = data.data.version
            // 分页
            this.pages = data.data.pages
            this.total = data.data.total
            this.size = data.data.size
            this.currentPage = data.data.current
            // 筛选器
            let region = []
            let city = []
            let employeeNm = []
            let roleLevel = []
            let kpi = []
            let incentiveRate = []
            let mudId = []
            let isAdjust = []
            this.region = this.FilterRendering(data.data.regions, region)
            this.city = this.FilterRendering(data.data.citys, city)
            this.employeeNm = this.FilterRendering(data.data.employeeNms, employeeNm)
            this.roleLevel = this.FilterRendering(data.data.roleLevels, roleLevel)
            this.kpi = this.FilterRendering(data.data.kpis, kpi)
            this.incentiveRate = this.FilterRendering(data.data.incentiveRates, incentiveRate)
            this.mudId = this.FilterRendering(data.data.mudIds, mudId)
            this.isAdjust = this.FilterRendering(data.data.isAdjusts, isAdjust)
            tableDataAdjust.forEach((ele) => {
              // 奖金基数
              ele.incentiveRate = this.formatNum(ele.incentiveRate, 4)
              // 季度发放比例
              // ele.quarterRate = this.formatNum(ele.quarterRate, 2)
              ele.quarterRate = this.formatNum100(ele.quarterRate, 2)
              ele.quarterRateAdjust = this.formatNum100(ele.quarterRateAdjust, 2)
              // 权重
              ele.kpiWeight = this.formatNum(ele.kpiWeight, 0)
              // 达成
              ele.kpiAch = this.formatNum(ele.kpiAch, 2)
              ele.kpiAchAdjust = this.formatNum(ele.kpiAchAdjust, 2)
              // 达成系数
              ele.coffient = this.formatNum(ele.coffient, 4)
              ele.coffientAdjust = this.formatNum(ele.coffientAdjust, 4)
              // 最终结果
              ele.kpiScore = this.formatNum(ele.kpiScore, 4)
              ele.adjustAfterKpiScore = this.formatNum(ele.adjustAfterKpiScore, 4)
            })
            tableDataAdjust.sort(this.mysort)
            this.tableDataAdjust = tableDataAdjust
            // 清除筛选项
            this.searchList = this.templateData()
          } else {
            this.fullscreenLoading = false
            this.$message.error('接口调用失败！')
          }
        })
      } else {
        this.$message.warning('请编辑调整！')
      }
    },
    changeRowQuarterRateAdjust (row) {
      // console.log(row)
      // console.log(this.tableDataAdjustCalu)
      row.quarterRateAdjust = row.quarterRateAdjust === '' ? null : row.quarterRateAdjust
      let tableDataAdjustCalu = this.tableDataAdjustCalu.filter(ele => {
        return (ele.employeeId === row.employeeId && ele.kpi !== row.kpi) || (ele.employeeId !== row.employeeId)
      })
      // console.log(tableDataAdjustCalu)
      this.tableDataAdjustCalu = tableDataAdjustCalu
      this.tableDataAdjustCalu.push(row)
      // console.log(this.tableDataAdjustCalu)
    },
    changeRowKpiWeightAdjust (row) {
      // console.log(row)
      // console.log(this.tableDataAdjustCalu)
      row.kpiWeightAdjust = row.kpiWeightAdjust === '' ? null : row.kpiWeightAdjust
      let tableDataAdjustCalu = this.tableDataAdjustCalu.filter(ele => {
        return (ele.employeeId === row.employeeId && ele.kpi !== row.kpi) || (ele.employeeId !== row.employeeId)
      })
      this.tableDataAdjustCalu = tableDataAdjustCalu
      this.tableDataAdjustCalu.push(row)
      // console.log(this.tableDataAdjustCalu)
    },
    changeRowKpiAchAdjust (row) {
      row.kpiAchAdjust = row.kpiAchAdjust === '' ? null : row.kpiAchAdjust
      let tableDataAdjustCalu = this.tableDataAdjustCalu.filter(ele => {
        return (ele.employeeId === row.employeeId && ele.kpi !== row.kpi) || (ele.employeeId !== row.employeeId)
      })
      this.tableDataAdjustCalu = tableDataAdjustCalu
      this.tableDataAdjustCalu.push(row)
      // console.log(this.tableDataAdjustCalu)
    },
    changeRowCoffientAdjust (row) {
      row.coffientAdjust = row.coffientAdjust === '' ? null : row.coffientAdjust
      let tableDataAdjustCalu = this.tableDataAdjustCalu.filter(ele => {
        return (ele.employeeId === row.employeeId && ele.kpi !== row.kpi) || (ele.employeeId !== row.employeeId)
      })
      this.tableDataAdjustCalu = tableDataAdjustCalu
      this.tableDataAdjustCalu.push(row)
      // console.log(this.tableDataAdjustCalu)
    },
    // 附件多选
    selectionChange (val) {
      // console.log(val)
      this.multipleSelection = val
    },
    // 添加附件和描述
    addAttachment () {
      if (this.multipleSelection.length > 0) {
        // console.log(this.multipleSelection)
        let unadjusted = this.multipleSelection.filter(ele => {
          return ele.quarterRateAdjust === null && ele.kpiWeightAdjust === null &&
            ele.kpiAchAdjust === null && ele.coffientAdjust === null
        })
        // console.log(unadjusted)
        if (unadjusted.length > 0) {
          this.$message.warning('请调整编辑后上传附件！')
        } else {
          this.dialog = true
        }
      } else {
        this.$message.warning('请勾选上传附件！')
      }
    },
    // 附件和描述-取消
    cancel () {
      if (this.editData.attachment !== '' && this.editData.adjustGistDesc === '') {
        this.$message.warning('请填写描述！')
      } else {
        this.$refs.editDataRef.resetFields()
        this.dialog = false
      }
    },
    // 附件和描述-确认
    confirm () {
      this.$refs.editDataRef.validate((valid) => {
        if (valid) {
          this.dialog = false
          let data = []
          this.multipleSelection.forEach((ele) => {
            data.push({
              id: ele.adjustId,
              adjustGistDesc: this.editData.adjustGistDesc
            })
          })
          this.$http.post(this.API.attachmentsDescUpdateInfos, data).then(res => {
            this.$message.success('添加成功！')
            this.$refs.editDataRef.resetFields()
            // this.$refs.tableDataAdjustRef.clearSelection()
          })
        }
      })
    },
    // 附件上传前提示
    uploadTips () {
      this.$message.warning('请编辑调整！')
    },
    // 附件上传前校验
    beforeUpload (file) {
      // console.log(file)
      // file.name-文件名字
      // file.size-文件大小
      // file.type-文件类型
      // 上传前格式与大小校验
      const isExcel = file.type === 'application/pdf'
      // const isLt2M = file.size / 1024 / 1024 < 2
      if (!isExcel) {
        this.$message.error('上传模板只能是PDF格式!')
      }
      // if (!isLt2M) {
      //   this.$message.error('上传模板大小不能超过 2MB!')
      // }
      // return isJPG && isLt2M
      return isExcel
    },
    // 上传附件
    upload (e) {
      // console.log(e)
      let id = []
      this.multipleSelection.forEach((ele) => {
        id.push(ele.adjustId)
      })
      let formData = new FormData()
      let ids = id.join(',')
      formData.append('ids', ids)
      formData.append('file', e.file)
      this.$http.post(this.API.attachmentsUpload, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {
        // console.log(res)
        this.$message.success('附件上传成功！')
        this.editData.attachment = 'Y'
      })
    },
    // 下载附件
    download (row) {
      if (row.quarterRateAdjust !== null || row.kpiWeightAdjust !== null || row.kpiAchAdjust !== null || row.coffientAdjust !== null) {
        this.$http.get(this.API.attachmentsDownload, { params: { id: row.adjustId }, responseType: 'blob' }).then(res => {
        // console.log(res)
          let data = res.data
          let responseType = data.type || null
          if (responseType.includes('application/json')) {
            let reader = new FileReader()
            reader.onload = (e) => {
              // console.log(e)
              let msg = JSON.parse(e.target.result).msg
              if (msg) {
                this.$message.error(msg)
              } else {
                this.$message.error('接口调用失败！')
              }
            }
            reader.readAsText(data)
          } else {
            let blob = new Blob([data], { type: data.type })
            let downloadElement = document.createElement('a')
            let href = window.URL.createObjectURL(blob) // 创建下载的链接
            downloadElement.href = href
            downloadElement.download = row.employeeNm + '-' + row.kpi + '.pdf' // 下载后文件名
            document.body.appendChild(downloadElement) // 添加元素
            downloadElement.click() // 点击下载
            document.body.removeChild(downloadElement) // 下载完成移除元素
            window.URL.revokeObjectURL(href) // 释放掉blob对象
            this.$message.success('下载成功！')
          }
        })
      } else {
        this.$message.warning('请上传附件！')
      }
    },
    // 描述--查看
    viewDes (row) {
      if (row.quarterRateAdjust !== null || row.kpiWeightAdjust !== null || row.kpiAchAdjust !== null || row.coffientAdjust !== null) {
        this.$http.get(this.API.attachmentsDescQuery, { params: { id: row.adjustId } }).then(res => {
          // console.log(res)
          let data = res.data
          if (data.data !== null) {
            this.$alert(data.data.adjustGistDesc, '附件描述')
          } else {
            this.$message.warning('暂无数据！')
          }
        })
      } else {
        this.$message.warning('请编辑调整！')
      }
    },
    // 清除--没用到
    reset () {
      this.tableDataAdjust.forEach((ele) => {
        ele.quarterRateAdjust = null
        ele.kpiWeightAdjust = null
        ele.kpiAchAdjust = null
        ele.coffientAdjust = null
      })
    },
    // 保存
    saved () {
      if (this.tableDataAdjust.length > 0) {
        this.fullscreenLoading = true
        this.$http.post(this.API.trialSaved, { subVersionName: this.versionNameSub, version: this.version }).then((res) => {
          this.fullscreenLoading = true
          let data = res.data
          if (data.code === 200) {
            this.fullscreenLoading = false
            this.$message.success('保存成功！')
          } else {
            this.$message.error('接口调用失败！')
            this.fullscreenLoading = false
          }
        })
      } else {
        this.$message.warning('暂无数据！请试算或者查询！')
      }
    },
    // 发布
    publish () {
      if (this.tableDataAdjust.length > 0) {
        this.fullscreenLoading = true
        this.$http.post(this.API.trialPublish, { subVersionName: this.versionNameSub, version: this.version }).then((res) => {
          this.fullscreenLoading = true
          let data = res.data
          if (data.code === 200) {
            this.getQuarterBonusList(this.versionName)
            this.$message.success('发布成功！')
            this.fullscreenLoading = false
          } else {
            this.$message.error('接口调用失败！')
            this.fullscreenLoading = false
          }
        })
      } else {
        this.$message.warning('暂无数据！请试算或者查询！')
      }
    },
    // 下载
    downloadExcel () {
      this.$http.get(this.API.trialDownload, { params: { versionName: this.versionNameSub, version: this.version }, responseType: 'blob' }).then(res => {
        // console.log(res)
        let data = res.data
        let responseType = data.type || null
        if (responseType.includes('application/json')) {
          let reader = new FileReader()
          reader.onload = (e) => {
            // console.log(e)
            let msg = JSON.parse(e.target.result).msg
            if (msg) {
              this.$message.error(msg)
            } else {
              this.$message.error('接口调用失败！')
            }
          }
          reader.readAsText(data)
        } else {
          let blob = new Blob([data], { type: data.type })
          let downloadElement = document.createElement('a')
          let href = window.URL.createObjectURL(blob) // 创建下载的链接
          downloadElement.href = href
          downloadElement.download = this.versionNameSub + '.xls' // 下载后文件名
          document.body.appendChild(downloadElement) // 添加元素
          downloadElement.click() // 点击下载
          document.body.removeChild(downloadElement) // 下载完成移除元素
          window.URL.revokeObjectURL(href) // 释放掉blob对象
          this.$message.success('下载成功！')
        }
      })
    },
    // 行转列下载
    rowToColumnDownload () {
      this.$http.get(this.API.rowToColumnDownload, { params: { subVersionName: this.versionNameSub, version: this.version }, responseType: 'blob' }).then(res => {
        let data = res.data
        let responseType = data.type || null
        if (responseType.includes('application/json')) {
          let reader = new FileReader()
          reader.onload = (e) => {
            // console.log(e)
            let msg = JSON.parse(e.target.result).msg
            if (msg) {
              this.$message.error(msg)
            } else {
              this.$message.error('接口调用失败！')
            }
          }
          reader.readAsText(data)
        } else {
          let blob = new Blob([data], { type: data.type })
          let downloadElement = document.createElement('a')
          let href = window.URL.createObjectURL(blob) // 创建下载的链接
          downloadElement.href = href
          downloadElement.download = this.versionNameSub + '---奖金报告' + '.xls' // 下载后文件名
          document.body.appendChild(downloadElement) // 添加元素
          downloadElement.click() // 点击下载
          document.body.removeChild(downloadElement) // 下载完成移除元素
          window.URL.revokeObjectURL(href) // 释放掉blob对象
          this.$message.success('下载成功！')
        }
      })
    },
    templateData () {
      return {
        region: null,
        city: null,
        employeeNm: null,
        roleLevel: null,
        kpi: null,
        incentiveRate: null,
        mudId: null,
        isAdjust: null,
        kpiAch: null
      }
    },
    // 排序--员工/权重
    mysort (a, b) {
      if (a.employeeId !== b.employeeId) {
        return a.employeeId < b.employeeId ? -1 : 1
      } else {
        return a.kpiScore - b.kpiScore
      }
      // return a.eid - b.eid
    },
    // 上
    columnStyle ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return 'color:#337ab8;cursor:pointer'
      } else {
        return 'padding:3px 0'
      }
    },
    // 下
    columnStyle1 ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 9 || columnIndex === 11 || columnIndex === 13) {
        return 'padding:2px 0'
      }
    },
    // 点击行高亮
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex === this.highLight) {
        return 'success-row'
      }
      return ''
    },
    // 格式化数字
    formatNum (num, cen) {
      return num === null ? null : this.Tools.formatNumber(num, cen, 0)
    },
    formatNum100 (num, cen) {
      return num === null ? null : this.Tools.formatNumber(num, cen, 0) * 100
    },
    // 整数没小数位
    formatNum1 (num, cen) {
      return num === null ? null
        : (this.Tools.formatNumber(num, cen, 0) % 1 === 0 ? this.Tools.formatNumber(num, 0, 0)
          : this.Tools.formatNumber(num, cen, 0))
    },
    // 去除对象null值
    removePropertyOfNull (obj) {
      Object.keys(obj).forEach(item => {
        if (!obj[item]) delete obj[item]
      })
      return obj
    },
    // 多值同时筛选
    multiFilter (arr, filters) {
      // console.log(filters)
      let filterKeys = Object.keys(filters)
      // console.log(filterKeys)
      return arr.filter(ele => {
        return filterKeys.every(key => {
          if (filters[key] instanceof Array) {
            return !!~filters[key].indexOf(ele[key])
          } else {
            return ele[key] === filters[key]
          }
        })
      })
    },
    // 联动
    cascader () {
      // console.log(this.searchList)
      // 去除null值
      let searchList = this.removePropertyOfNull(this.searchList)
      // 多条件筛选
      let filter = this.multiFilter(this.tableDataAdjustAll, searchList)
      // console.log(filter)
      let region = []
      let city = []
      let employeeNm = []
      let roleLevel = []
      let kpi = []
      let incentiveRate = []
      let mudId = []
      filter.forEach((ele) => {
        region.push({
          label: ele.region,
          value: ele.region
        })
        city.push({
          label: ele.city,
          value: ele.city
        })
        employeeNm.push({
          label: ele.employeeNm,
          value: ele.employeeNm
        })
        roleLevel.push({
          label: ele.roleLevel,
          value: ele.roleLevel
        })
        kpi.push({
          label: ele.kpi,
          value: ele.kpi
        })
        incentiveRate.push({
          label: ele.incentiveRate,
          value: ele.incentiveRate
        })
        mudId.push({
          label: ele.mudId,
          value: ele.mudId
        })
      })
      // 去重
      this.region = this.Tools.deDuplicationArrObj(region, 'label')
      this.city = this.Tools.deDuplicationArrObj(city, 'label')
      this.employeeNm = this.Tools.deDuplicationArrObj(employeeNm, 'label')
      this.roleLevel = this.Tools.deDuplicationArrObj(roleLevel, 'label')
      this.kpi = this.Tools.deDuplicationArrObj(kpi, 'label')
      this.incentiveRate = this.Tools.deDuplicationArrObj(incentiveRate, 'label')
    },
    cascaderNew () {
      if (this.version) {
        this.fullscreenLoading = true
        this.tableDataAdjust = []
        let obj = {}
        obj.pageNum = 1
        obj.pageSize = this.size
        obj.version = this.version
        obj.subVersionName = this.versionNameSub
        obj.regions = this.searchList.region === null ? null : this.searchList.region.split(',')
        obj.citys = this.searchList.city === null ? null : this.searchList.city.split(',')
        obj.employeeNms = this.searchList.employeeNm === null ? null : this.searchList.employeeNm.split(',')
        obj.roleLevels = this.searchList.roleLevel === null ? null : this.searchList.roleLevel.split(',')
        obj.kpis = this.searchList.kpi === null ? null : this.searchList.kpi.split(',')
        obj.incentiveRates = this.searchList.incentiveRate === null ? null : this.searchList.incentiveRate.split(',')
        obj.mudIds = this.searchList.mudId === null ? null : this.searchList.mudId.split(',')
        obj.isAdjusts = this.searchList.isAdjust === null ? null : this.searchList.isAdjust.split(',')
        obj.kpiAch = this.searchList.kpiAch === null ? null : this.searchList.kpiAch * 1
        this.$http.post(this.API.callTrialResult, obj).then((res) => {
          let data = res.data
          if (data.code === 200) {
            this.fullscreenLoading = false
            if (data.data.records.length > 0) {
              // 分页
              this.pages = data.data.pages
              this.total = data.data.total
              this.size = data.data.size
              this.currentPage = data.data.current
              // 赋值数据列表
              let tableDataAdjust = data.data.records
              // console.log(tableDataAdjust)
              let region = []
              let city = []
              let employeeNm = []
              let roleLevel = []
              let kpi = []
              let incentiveRate = []
              let mudId = []
              let isAdjust = []
              this.region = this.FilterRendering(data.data.regions, region)
              this.city = this.FilterRendering(data.data.citys, city)
              this.employeeNm = this.FilterRendering(data.data.employeeNms, employeeNm)
              this.roleLevel = this.FilterRendering(data.data.roleLevels, roleLevel)
              this.kpi = this.FilterRendering(data.data.kpis, kpi)
              this.incentiveRate = this.FilterRendering(data.data.incentiveRates, incentiveRate)
              this.mudId = this.FilterRendering(data.data.mudIds, mudId)
              this.isAdjust = this.FilterRendering(data.data.isAdjusts, isAdjust)
              // 替换调整数据
              let tableDataAdjustCalu = JSON.parse(JSON.stringify(this.tableDataAdjustCalu))
              let tableDataAdjustConcat = []
              tableDataAdjustCalu.forEach(element => {
                element.quarterRate = element.quarterRate === null ? null : element.quarterRate / 100
                element.quarterRateAdjust = element.quarterRateAdjust === null ? null : element.quarterRateAdjust / 100
              })
              let tableDataAdjustNew = tableDataAdjust.filter((item) => {
                return !tableDataAdjustCalu.some(ele => ele.employeeId === item.employeeId && ele.mudId === item.mudId && ele.kpi === item.kpi)
              })
              let tableDataAdjustCaluNew = tableDataAdjustCalu.filter((item) => {
                return tableDataAdjust.some(ele => ele.employeeId === item.employeeId && ele.mudId === item.mudId && ele.kpi === item.kpi)
              })
              if (tableDataAdjustNew.length === tableDataAdjust.length) {
                tableDataAdjustConcat = tableDataAdjust
              } else {
                tableDataAdjustConcat = tableDataAdjustNew.concat(tableDataAdjustCaluNew)
              }
              tableDataAdjustConcat.forEach((ele) => {
                // 奖金基数
                ele.incentiveRate = this.formatNum(ele.incentiveRate, 4)
                // 季度发放比例
                // ele.quarterRate = this.formatNum(ele.quarterRate, 2)
                ele.quarterRate = this.formatNum100(ele.quarterRate, 2)
                ele.quarterRateAdjust = this.formatNum100(ele.quarterRateAdjust, 2)
                // 权重
                ele.kpiWeight = this.formatNum(ele.kpiWeight, 0)
                // 达成
                ele.kpiAch = this.formatNum(ele.kpiAch, 2)
                ele.kpiAchAdjust = this.formatNum(ele.kpiAchAdjust, 2)
                // 达成系数
                ele.coffient = this.formatNum(ele.coffient, 4)
                ele.coffientAdjust = this.formatNum(ele.coffientAdjust, 4)
                // 最终结果
                ele.kpiScore = this.formatNum(ele.kpiScore, 4)
                ele.adjustAfterKpiScore = this.formatNum(ele.adjustAfterKpiScore, 4)
              })
              tableDataAdjustConcat.sort(this.mysort)
              this.tableDataAdjust = tableDataAdjustConcat
            } else {
              this.$message.warning('暂无数据！')
            }
          } else {
            this.fullscreenLoading = false
            this.$message.error('接口调用失败！')
          }
        })
      } else {
        this.$message.warning('请先试算或查询！')
      }
    },
    FilterRendering (arr, fieldArr) {
      if (arr !== null) {
        arr.forEach(ele => {
          fieldArr.push({
            label: ele,
            value: ele
          })
        })
        return fieldArr
      } else {
        return []
      }
    }
  }
}
</script>

<style lang="less" scoped>
.adjustPublish {
  .totalClass {
    color: #000;
    font-weight: bold;
  }
  .foot_button {
    text-align: right;
    margin-top: 15px;
  }
  .table-status {
    width: 100%;
    border-radius: 6px;
    /deep/.headerStyle {
      background-color: #007f90 !important;
      color: #fff;
      font-weight: normal;
      padding: 8px 0;
    }
    /deep/.headerStyle1 {
      background-color: #007f90 !important;
      color: #fff;
      font-weight: normal;
      padding: 1px 0;
    }
    /deep/.cellStyle {
      padding: 5px 0;
    }
    /deep/.el-input__inner {
      height: 35px;
      line-height: 35px;
      padding: 0 5px;
    }
  }
  /deep/.el-table .success-row {
    background: #f0f9eb;
    // background: red;
  }
  // 全选加文字
  /deep/ .el-table__header-wrapper .el-checkbox__input::after {
    content: '上传附件';
    position: absolute;
    margin-left: 5px;
    color: #fff;
  }
  /deep/ .el-table-column--selection .cell {
    padding-left: 10px;
  }
}
</style>
